/**
 * Descriptions for all filter tags produced by the QA agent's call analytics filters.
 * Used as tooltip text when hovering over tag badges in Frauds and FraudDetails views.
 */
const FILTER_TAG_DESCRIPTIONS = {
  // Fraud pattern tags
  Fraud_Detected: 'Direct fraud detection flag was triggered for this call.',
  Fraudulent_Conversion: 'Converted call where agent coaching and misleading claims were detected.',
  Financial_Scam: 'Suspicious payment methods discussed (gift cards, wire transfers, crypto).',
  High_Stress_Scam: 'Impersonation detected while the caller shows high stress or negative sentiment.',
  Lead_Provider_Fraud: 'Call originated from a robocall lead source, indicating fraudulent lead generation.',
  Buffer_Arbitrage: 'Call dropped near buffer threshold with gaming phrases \u2014 possible buffer manipulation.',
  Bot_Caller: 'Caller is suspected to be an AI/bot wasting agent time.',
  Suspicious_Source: 'Call originated from a suspicious or unverified traffic source.',

  // Compliance tags
  Critical_Compliance: 'Critical regulatory violation: outbound claim with no recording disclosure and high TCPA risk.',
  TCPA_Violation: 'Outbound call with no recording disclosure and high TCPA risk heuristics.',
  TCPA_Critical: 'Call involves critical TCPA (Telephone Consumer Protection Act) concerns.',

  // Severity / routing tags
  Critical_Review: 'Requires immediate review by the compliance team.',
  High_Priority: 'Elevated priority for expedited review.',
  Prune_Agent_Queue: 'Non-actionable call \u2014 should be removed from agent review queues.',

  // False positive tags
  False_Positive: 'Flag identified as a false positive \u2014 can be disregarded.',
  CH1_Evidence: 'Outbound/SMS evidence came from agent channel (CH1) instead of caller channel (CH0).',
}

export default FILTER_TAG_DESCRIPTIONS
